"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Steps = function (props) {
    var _a;
    var size = props.size, steps = props.steps, _b = props.percent, percent = _b === void 0 ? 0 : _b, _c = props.strokeWidth, strokeWidth = _c === void 0 ? 8 : _c, strokeColor = props.strokeColor, trailColor = props.trailColor, prefixCls = props.prefixCls, children = props.children;
    var current = Math.round(steps * (percent / 100));
    var stepWidth = size === 'small' ? 2 : 14;
    var styledSteps = [];
    for (var i = 0; i < steps; i += 1) {
        styledSteps.push(React.createElement("div", { key: i, className: (0, classnames_1.default)("".concat(prefixCls, "-steps-item"), (_a = {},
                _a["".concat(prefixCls, "-steps-item-active")] = i <= current - 1,
                _a)), style: {
                backgroundColor: i <= current - 1 ? strokeColor : trailColor,
                width: stepWidth,
                height: strokeWidth,
            } }));
    }
    return (React.createElement("div", { className: "".concat(prefixCls, "-steps-outer") },
        styledSteps,
        children));
};
exports.default = Steps;
//# sourceMappingURL=Steps.js.map